<div class="payment-confirm-page">
  <div class="modal-lg payment-confirm-shell">
    <div class="modal-body content payment-confirm-content">
      <!-- Modal body -->
      <div class="modal-body payment-confirm-body">
        <div class="row">
          <div *ngIf="isLoading" role="status">Checking booking status...</div>
          <div *ngIf="bookingMessage" class="payment-empty-cart" role="alert">
            <p>{{ bookingMessage }}</p>
            <a routerLink="/landing-page/transactions">Back to transactions</a>
          </div>
          <div class="col-12 payment-confirm-main" *ngIf="!bookingMessage && bookings.length > 0 && products.length > 0">

            <div class="payment-confirm-header">
              <h2>Confirm Details</h2>
              <p>Review your booking before payment</p>
            </div>

            <div class="payment-confirm-section">
              <label class="payment-section-title">Facility Details</label>
              <table class="table table-borderless transaction-details-table payment-detail-table">
                <tr>
                  <td class="bookedSlotsFieldName" >NAME</td>
                  <td class="bookedSlotsFieldValue" >{{tenant?.tenantName}}</td>
                </tr>
                <tr>
                  <td class="bookedSlotsFieldName">ADDRESS</td>
                  <td class="bookedSlotsFieldValue" >{{tenant?.address?.addressLine1}}, {{tenant?.address?.addressLine2}}, {{tenant?.address?.city}},
                    {{tenant?.address?.pinCode}}, </td>
                </tr>
              </table>
            </div>
            <div class="payment-confirm-section">
              <label class="payment-section-title">Booking Details</label><br />
              <table class="table table-borderless transaction-details-table payment-detail-table">
                <tr>
                  <td class="bookedSlotsFieldName">BOOKING ID</td>
                  <td class="bookedSlotsFieldValue bold" style="font-size: 0.9rem;">{{bookings[0].confirmationId}}</td>
                </tr>
              </table>
            </div>
            <div class="payment-confirm-section">
              <label class="payment-section-title">Slots</label><br />
              <!--//<label class="bookedSlotsFieldName" style="font-size: 0.9rem;">BOOKING ID : {{bookings[0].confirmationId}}</label>-->
              <div class="payment-slot-group" *ngFor="let group of groupedSlots">
                <div class="payment-slot-heading">
                  <span class="payment-slot-product">{{ getProductName(group.productId) }}</span>
                  <span class="payment-slot-venue">{{group.venueName}}</span>
                </div>
                <div class="payment-slot-row" *ngFor="let slotObj of group.slots">
                  <span class="payment-slot-date">{{slotObj.bookingDate}}</span>
                  <span class="payment-slot-time">{{formatTime(slotObj.startTime)}} - {{formatTime(slotObj.endTime)}}</span>
                  <strong class="payment-slot-price">{{slotObj.amount | number:'1.2-2'}}</strong>
                </div>
              </div>
            </div>
            <div class="payment-confirm-section" *ngIf="groupedAddOns.length > 0">
              <label class="payment-section-title">Add-ons</label>
              <div class="payment-slot-card payment-addon-card" *ngFor="let addOn of groupedAddOns">
                <div class="payment-addon-name">{{ getProductName(addOn.productId) || addOn.productName || 'Add-on' }}</div>
                <div class="payment-addon-details">
                  <span>Qty: {{ getAddOnQuantity(addOn) ?? 'Not recorded' }}</span>
                  <span *ngIf="getAddOnUnitPrice(addOn) !== null; else paymentLinkMissingPrice">Unit price: Rs. {{ getAddOnUnitPrice(addOn) | number:'1.2-2' }}</span>
                  <ng-template #paymentLinkMissingPrice><span>Unit price: Not recorded</span></ng-template>
                  <strong>Total: Rs. {{ addOn.amount | number:'1.2-2' }}</strong>
                </div>
              </div>
            </div>
            <div class="payment-confirm-section" *ngIf="discountAmount > 0">
              <label class="payment-section-title">Discount</label>
              <table class="table table-borderless transaction-details-table payment-detail-table">
                <tr *ngIf="discountAmount > 0">
                  <td class="bookedSlotsFieldName">SUBTOTAL</td>
                  <td class="bookedSlotsFieldValue">Rs. {{subTotal | number:'1.2-2'}}/-</td>
                </tr>
                <tr *ngIf="discountAmount > 0">
                  <td class="bookedSlotsFieldName">DISCOUNT</td>
                  <td class="bookedSlotsFieldValue" style="color: green;">- Rs. {{discountAmount | number:'1.2-2'}}/-</td>
                </tr>
              </table>
            </div>
            <div class="payment-confirm-section">
              <label class="payment-section-title">Payment</label>
              <table class="table table-borderless transaction-details-table payment-detail-table">
                <tr>
                  <td class="bookedSlotsFieldName">PLATFORM FEE (END USER)</td>
                  <td class="bookedSlotsFieldValue">Rs. {{totalPlatformFeeEndUser | number:'1.2-2'}}/-</td>
                </tr>
                <tr>
                  <td class="bookedSlotsFieldName">TOTAL</td>
                  <td class="bookedSlotsFieldValue bold">Rs. {{totalSum | number:'1.2-2'}}/-</td>
                </tr>
              </table>
            </div>
            <!-- Warning 1: Do not refresh -->
            <div class="card bg-light border-warning mb-3 payment-warning-card">
              <div class="card-body d-flex align-items-start">
                <i class="bi bi-exclamation-triangle-fill text-warning me-2 mt-1"></i>
                <div>
                  <h6 class="card-title mb-1 fw-bold" style="color:red;">Important</h6>
                  <p class="card-text mb-0">
                    After clicking "Pay Now", please do not refresh or close the payment screen until the payment is
                    completed.
                  </p>
                </div>
              </div>
            </div>

<!--            &lt;!&ndash; Warning 2: Transaction charges &ndash;&gt;
            <div class="card bg-light border-warning mb-3">
              <div class="card-body d-flex align-items-start">
                <i class="bi bi-exclamation-triangle-fill text-warning me-2 mt-1"></i>
                <div>
                  <h6 class="card-title mb-1 fw-bold" style="color:red;">Transaction Charges May Apply</h6>
                  <div class="charge-row"><span class="method">UPI (Bank-linked)</span><span class="charge">No
                      Charge</span></div>
                  <div class="charge-row"><span class="method">UPI (Credit Card-linked)</span><span
                      class="charge">3%</span></div>
                  <div class="charge-row"><span class="method">Wallets</span><span class="charge">3%</span></div>
                  <div class="charge-row"><span class="method">Credit/Debit Card, Netbanking</span><span
                      class="charge">3%</span></div>
                </div>
              </div>
            </div>-->

            <div class="expiry-date bold" *ngIf="formattedExpiry">
              <label>Booking Expiration : {{formattedExpiry}}</label>
            </div>


            <div class="payment-confirm-actions" *ngIf="bookings[0].bookingStatus === 'WaitingForPayment' && !isBillDeskPaymentActive">
              <button type="button" class="btn payment-cancel-action" [disabled]="isPaymentPending" (click)="cancelBooking(confirmCancel)">Cancel</button>
              <button type="button" class="btn payment-pay-action" [disabled]="isPaymentPending" (click)="payNow()">Pay Rs. {{totalSum | number:'1.2-2'}}</button>
            </div>
          </div>
          <!--<div class="justify-content-center">
                                <button type="button" class="btn btn-outline-dark cancel_btn" id="close-modal" (click)="hideModal()">Cancel</button>
                                <button type="button" class="btn btn-primary book-now-btn">Pay Now</button>
                            </div>-->
          <div class="payment-empty-cart" *ngIf="!isLoading && !bookingMessage && bookings.length === 0">
            <h2>Cart is empty</h2>
            <p>No slots are available for payment. Please add slots before continuing.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #confirmCancel let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Confirm</h5>
      <button type="button" class="btn-close"
              aria-label="Close"
              (click)="modal.dismiss('cancel')">
      </button>
    </div>

    <div class="modal-body">
      Are you sure you want to cancel this booking? It will release the blocked slots.
    </div>

    <div class="modal-footer">
      <button class="btn btn-danger"
              (click)="modal.close('yes')">
        Yes
      </button>
      <button class="btn btn-secondary"
              (click)="modal.dismiss('no')">
        No
      </button>
    </div>
  </ng-template>

</div>
